import ClutterImpactPage from './ClutterImpactPage'
import CommitmentPage from './CommitmentPage'
import CompletePage from './CompletePage'
import FeelingPage from './FeelingPage'
import FeelingsPage from './FeelingsPage'
import GoalsFeedbackPage from './GoalsFeedbackPage'
import GoalsPage from './GoalsPage'
import LetGoPage from './LetGoPage'
import NotAloneFeedbackPage from './NotAloneFeedbackPage'
import ObstaclePage from './ObstaclePage'
import OvercomeFeedbackPage from './OvercomeFeedbackPage'
import PastAttemptsPage from './PastAttemptsPage'
import RoomPage from './RoomPage'
import StressLevelPage from './StressLevelPage'
import StylePage from './StylePage'
import SuggestionsPage from './SuggestionsPage'
import SustainabilityPage from './SustainabilityPage'
import UnsurePage from './UnsurePage'
import VibePage from './VibePage'

import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'

const onboardingRoutes = [
  {
    action: navigateToNextOnboardingPageAction,
    element: <VibePage />,
    path: 'vibe',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <ClutterImpactPage />,
    path: 'clutter-impact',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <GoalsPage />,
    path: 'goals',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <GoalsFeedbackPage />,
    path: 'goals-feedback',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <RoomPage />,
    path: 'room',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <FeelingsPage />,
    path: 'feelings',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <NotAloneFeedbackPage />,
    path: 'not-alone-feedback',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <StylePage />,
    path: 'style',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <UnsurePage />,
    path: 'unsure',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <PastAttemptsPage />,
    path: 'past-attempts',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <ObstaclePage />,
    path: 'obstacle',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <OvercomeFeedbackPage />,
    path: 'overcome-feedback',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <LetGoPage />,
    path: 'letgo',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <StressLevelPage />,
    path: 'stress-level',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <SustainabilityPage />,
    path: 'sustainability',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <SuggestionsPage />,
    path: 'suggestions',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <CommitmentPage />,
    path: 'commitment',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <FeelingPage />,
    path: 'feeling',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <CompletePage />,
    path: 'complete',
  },
]

export default onboardingRoutes
